import { createContext, useContext } from 'react';

import { SettingsListItem } from './types';

type SettingsContent = {
  filterOptions?: { value: number | null; label: string }[];
  isMultipleSelection: boolean;
  page: number;
  searchTerm: string;
  status: number | null;
  communities: any[];
  communitiesTotalCount: number;
  selectedCommunitiesIds: number[];
  allCommunitiesSelected: boolean;
  headerContent: SettingsListItem;
  pageSize: number;
  loadingCommunities: boolean;
  companiesFilter: number[];
  setPageSize: (i: number) => void;
  getItemStatusComponent: (item: any) => React.ReactNode | undefined;
  toggleAllCommunities: () => void;
  toggleOneCommunity: (item: any) => void;
  setCompaniesFilter: (item: any) => void;
};

export const SettingsContext = createContext<SettingsContent>({
  isMultipleSelection: false,
  page: 1,
  pageSize: 20,
  searchTerm: '',
  status: null,
  communities: [],
  communitiesTotalCount: 0,
  selectedCommunitiesIds: [],
  allCommunitiesSelected: false,
  headerContent: {
    title: '',
    description: '',
    icon: {
      backgroundColor: '',
      url: '',
    },
    url: '',
    section: '',
  },
  loadingCommunities: true,
  companiesFilter: [],
  setPageSize: (i: number) => {
    // empty
  },
  getItemStatusComponent: () => undefined,
  toggleAllCommunities: () => undefined,
  toggleOneCommunity: () => undefined,
  setCompaniesFilter: () => undefined,
});

export const useSettingsContext = () => useContext(SettingsContext);
